function getFormatDate(date) {

    let year = date.getFullYear();
    let month = (1+ date.getMonth());
    
    month = month >= 10 ? month : '0' + month;
    
    let day = date.getDate();
  
    day = day >= 10 ? day : '0' + day;
  
    return year + '-' + month + '-' + day;
    
  }
  
function getWeekDate() {

    let currentDay = new Date();  
    let theYear = currentDay.getFullYear();
    let theMonth = currentDay.getMonth();
    let theDate  = currentDay.getDate();
    let theDayOfWeek = currentDay.getDay();

    let week = [];

    for(let i = 0; i < 7; i++) {

        let resultDay = new Date(theYear, theMonth, theDate + (i -theDayOfWeek));
        let yyyy = resultDay.getFullYear();
        let mm = Number(resultDay.getMonth()) + 1;
        let dd = resultDay.getDate();
        
        mm = String(mm).length === 1 ? '0' + mm : mm;
        dd = String(dd).length === 1 ? '0' + dd : dd;
        
        week[i] = yyyy + '-' + mm + '-' + dd;

    }

    let formatWeekDate = [week[0],week[6]];

    return formatWeekDate;
    
}

function getMonthDate() {

    let date = new Date();

    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let formatWeekDate = [firstDay,lastDay];

    return formatWeekDate;

}

function getWeekNumberOfMonth(date) {
    const currentDate = date.getDate();
    const firstDay = new Date(date.setDate(1)).getDay();
  
    return Math.ceil((currentDate + firstDay) / 7);
};

// 서버 · DB 와 같은 KST 벽시계 'YYYY-MM-DD HH:mm:ss.SSS' — 브라우저 로컬 시각(KST)을 그대로 적는다
function toKstWallClock(date) {

    // 날짜 칸을 비운 null · 잘못된 Date 는 그대로 돌려준다(URL 에 넣던 예전 값과 같게)
    if (!(date instanceof Date) || isNaN(date)) return date;

    const pad = (n, w = 2) => String(n).padStart(w, "0");

    return `${getFormatDate(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`;

}

// Date.prototype.toJSON 대체(src/index.js) — 잘못된 Date 는 원래 toJSON 처럼 null
function kstDateToJSON() {

    return isNaN(this) ? null : toKstWallClock(this);

}

export {getFormatDate, getMonthDate, getWeekDate, getWeekNumberOfMonth, toKstWallClock, kstDateToJSON};